var _defs, _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgESickNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M20.395 30.473l-2.332 4.037-1.038 1.796a4.275 4.275 0 01-7.403-4.277l3.213-5.502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.783 30.427l-6.947-3.899.395-.744 2.865-4.959a4.275 4.275 0 017.403 4.277l-2.177 3.768-1.045 1.809-.493-.252z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M7.436 23.741V12.066M34.235 15.806v-5.269a5.636 5.636 0 00-5.631-5.641H14.443M14.44 5.001l-7.062 7.062M15.319 6.226v6.687H8.248"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.913 25.219l4.077-3.933 3.934 4.077M33.983 21.64l-.129 9.994"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4D_dot",
    cx: 33.919,
    cy: 36.509,
    r: 1.77,
    transform: "rotate(-31.632 33.918 36.51)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESickNote);
export default __webpack_public_path__ + "static/media/eSickNote.5c9f8c181bb481a50893d82d89034dec.svg";
export { ForwardRef as ReactComponent };